// @flow
import React from 'react';
import { useField } from 'formik';
import classNames from 'classnames';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  label: string,
  placeholder: string,
  name: string,
  className?: string,
  type?: string,
  valueType?: string,
  disabled?: boolean,
};

export const FormInput = ({
  label,
  className = '',
  id = '',
  valueType = '',
  disabled = false,
  ...props
}: Props) => {
  const [field, meta] = useField(props);
  const hasError = meta.touched && meta.error;
  const error = meta.error;
  const numberRegex = valueType === 'decimal' ? /[0-9.]/ : /[0-9]/;

  if (hasError) {
    label = error;
  }

  const containerClass = classNames('form-input form-field', className, {
    'field-error': hasError,
  });

  const onKeyPress = e => {
    const keyCode = e.keyCode || e.which;
    const keyValue = String.fromCharCode(keyCode);
    if (props.type === 'number' && !numberRegex.test(keyValue)) {
      e.preventDefault();
    }
  };

  return (
    <div className={containerClass} key={id || field.name}>
      <input
        id={id || field.name}
        {...field}
        {...props}
        onKeyPress={onKeyPress}
        disabled={disabled}
      />
      <label htmlFor={id || field.name}>{label}</label>
    </div>
  );
};
